import { isPositiveNumber } from "et3-type-guards";
import { TCorePage } from "../../../../../Types";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";

const ReportNumber = withLiteObserverAndTheme<{
  pageName: TCorePage;
  status: string;
  reportNumberFromPartition: number;
  reportsPartitionMaxNumber: number;
}>((props) => {
  const {
    theme,
    pageName,
    status,
    reportNumberFromPartition,
    reportsPartitionMaxNumber
  } = props;
  const { colors } = theme;
  const reportsPage = pageName === "REPORTS";
  const pendingReport = status === "pending";
  const shouldShow =
    reportsPage &&
    pendingReport &&
    isPositiveNumber(reportNumberFromPartition) &&
    isPositiveNumber(reportsPartitionMaxNumber);

  return shouldShow ? (
    <ET3Div
      isScrollable={false}
      width={100}
      height={40}
      color={colors.all.transparent}
      isExtendable={false}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      style={{
        borderRadius: 20,
        border: `2px solid ${colors.all.red}`
      }}
      onClick={() => {}}
    >
      {reportNumberFromPartition}/{reportsPartitionMaxNumber}
    </ET3Div>
  ) : null;
});

export default ReportNumber;
